import {InfoCircleOutlined} from '@ant-design/icons';
import {Badge, Button, ConfigProvider, FloatButtonProps} from 'antd';
import {useQuerableLayerContext} from '../../../../context/baseMap/QuerableLayerContext';
import {useTranslation} from 'react-i18next';
import {capitalize} from 'lodash';
import React from 'react';
import {useBaseWMSLayerContext} from '../../../../context/baseMap/BaseWMSLayerContext';

export const QueryModeButtons = (props: FloatButtonProps) => {

  const {t} = useTranslation();

  const [, currentWMSLayer] = useBaseWMSLayerContext();

  const [
    queryType,
    setQueryType,
  ] = useQuerableLayerContext();

  return (
    <ConfigProvider
      theme={{
        token: {
          colorBgContainerDisabled: '#F5F5F5',
        },
      }}
    >
      <Badge
        dot={true}
        count={+(queryType === 'GET_FEATURE_INFO')}
      >
        <Button
          icon={<InfoCircleOutlined
            style={{color: queryType === 'GET_FEATURE_INFO' ? '#4096ff' : '#000'}}
          />}
          style={{border: queryType === 'GET_FEATURE_INFO' ? '1.5px solid #4096ff' : '1px solid #d9d9d9'}}
          size={'large'}
          disabled={currentWMSLayer === null || queryType === 'GET_POLYGON_FROM_LAYER'}
          title={capitalize(t('map.layerQuery'))}
          onClick={() => setQueryType(mode => mode === 'GET_FEATURE_INFO' ? null : 'GET_FEATURE_INFO')}
        />
      </Badge>
    </ConfigProvider>
  );
};